<template>
  <div class="page-content" style="margin-top: 20px">
    <el-row  class="search-title common-table-top">
      <el-col :span="4" class="order-list-text" style="text-align: left">
        <i class="iconfont icon-icon-chankanmendian" style="color: #4882ff"></i>
        <span>编辑成员</span>
      </el-col>
    </el-row>

    <el-row class="box-content">
      <div class="box-content-div form-submit-page">
        <el-form ref="form" :model="form" :rules="rules" class="box-content-form" label-width="145px">
          <el-form-item label="姓名：" prop="realname">
            <el-input v-model.trim="form.realname" class="h-40 w-200"></el-input>
          </el-form-item>
          <el-form-item label="账号：" prop="username">
            <el-input disabled v-model.trim="form.username" class="h-40 w-200" :maxlength=12></el-input>
          </el-form-item>
          <el-form-item label="登录密码：" prop="password">
            <el-input type="password" v-model.trim="form.password" class="h-40 w-200"></el-input>
          </el-form-item>
<!--          <el-form-item label="确认密码：" prop="confirmPsd">-->
<!--            <el-input type="password" v-model.trim="form.confirmPsd" class="h-40 w-200"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="手机：" prop="mobile">
            <el-input v-model.trim="form.mobile" class="h-40 w-200" :maxlength=12></el-input>
          </el-form-item>
          <el-form-item label="所属部门：" prop="structureId">
            <el-cascader
                    ref="cascaderHandleSearchOne"
                    placeholder="请选择部门"
                    class="first-attr behavior-dimension arrowPositionSelect"
                    size="large"
                    clearable
                    change-on-select
                    :props="props"
                    :options="orgsOptions"
                    v-model="structureId"
                    @change="updateDepartmentOne"
            ></el-cascader>
          </el-form-item>
          <el-form-item class="checkbox-groups" label="角色：" prop="groupIds">
            <el-select filterable v-model="group_id" multiple placeholder="请选择角色" class="w-200" @change="changeRole">
              <el-option v-for="item in groups" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model.trim="form.remark" class="h-40 w-200"></el-input>
          </el-form-item>
          <el-form-item label="品鉴酒组织机构：">
            <div v-for="(item, index) in wineOrg" :key="index">
              <div style="display: flex;justify-content: left;align-items: center;padding-bottom: 10px">
                <el-cascader
                        ref="cascaderHandleSearch"
                        placeholder="请选择组织机构"
                        class="first-attr behavior-dimension arrowPositionSelect"
                        size="large"
                        clearable
                        change-on-select
                        :props="props"
                        :options="constructList"
                        v-model="item.id"
                        @change="updateDepartment"
                ></el-cascader>
                <i v-if="index === 0" @click="handleAdd" class="el-icon-plus" style="font-size: 20px;margin-left: 10px;cursor: pointer"></i>
                <i v-else class="delete-btn el-icon-close" @click="handleDelete(index)" style="font-size: 20px;cursor:pointer;padding-left: 10px;"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
             <el-button class="second-page-btn" style="float: left;margin-top:50px;" type="primary" @click="edit('form')" :loading="isLoading">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>
import { updateMemberList, getRoleList, getDepartmentList, getMemberDetail } from '@/api/analyse.js'
import { getListTree } from '@/api/constrct.js'
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    // 验证手机号
    var validateMobile = (rule, value, callback) => {
      if(!(/^1[3456789]\d{9}$/.test(value))){
        callback(new Error('请输入正确手机号'))
      } else {
        callback()
      }
    }
    return {
      props: {value: 'id', label: 'text', emitPath: true, checkStrictly: true, expandTrigger: 'hover'},
      isLoading: false,
      wineOrg: [{
        id: []
      }],
      constructList: [],
      group_id: [], // 临时存储，添加编辑需要删除该字段
      form: {
        id: '',
        wineOrg: [],
        username: '', // 账号
        password: '', // 密码
        passwordRep: '', // 确认密码
        realname: '', // 姓名
        mobile: '', // 手机号
        structureId: null, // 部门id
        structureData: [],
        remark: '', // 备注
        groupIds: '' // 角色
      },
      structureId: [],
      groups: [],
      orgsOptions: [],
      groupOptions: [],
      selectedGroups: [],
      selectedIds: [],
      recordPwd: '',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: false, message: '请输入用户密码', trigger: 'blur' }
        ],
        passwordRep: [
          { required: true, message: '请输入确认密码' },
          { validator: validatePass, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        structureId: [
          { required: true, message: '请选择所属部门', trigger: 'change' }
        ],
        groupIds: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    // 改变角色
    changeRole (val) {
      this.form.groupIds = val.join(',') || ''
    },
    // 点击添加
    handleAdd () {
      this.wineOrg.push({
        id: []
      })
    },
    // 获取组织机构选中的数组
    getConstList() {
      let newList = []
      if (this.wineOrg.length !== 0) {
        this.wineOrg.forEach(function(item, index) {
          let lst = item.id.length-1
          newList.push(item.id[lst])
        })
      }
      return newList
    },
    // 点击删除
    handleDelete (index) {
      this.wineOrg.splice(index, 1)
    },
    updateDepartment (val) {
      // this.searchDate.departmentId = val[val.length-1]
    },
    // 获取组织机构列表
    getListTree () {
      let params = {
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId')
      }
      getListTree(params).then(res => {
        if (res.data.code === '200') {
          if (res.data.result.id === '-1') {
            this.constructList = this.getTreeData(res.data.result.children)
          } else {
            let arr = []
            arr.push(res.data.result)
            this.constructList = this.getTreeData(arr)
          }
        } else {
          this.constructList = []
        }
      })
    },
    edit(form) {
      this.$refs.form.validate((pass) => {
        if (pass) {
          if (this.wineOrg.length > 1) {
            let isHas = true
            for (var i=0;i< this.wineOrg.length;i++) {
              if (this.wineOrg[i].id.length === 0) {
                isHas = false
              }
            }
            if (isHas) {
              this.editWay()
            } else {
              this.$message({
                type: 'warning',
                message: '请选择组织机构!'
              })
            }
          } else {
            this.editWay()
          }
        }
      })
    },
    editWay () {
      this.form.structureData = this.structureId || []
      this.form.wineOrg = this.wineOrg || []
      if (this.form.password === this.recordPwd) {
        this.form.password = ''
        this.form.passwordRep = ''
      }
      if (this.form.password !=='') {
        this.form.passwordRep = this.form.password
      }
      updateMemberList(this.form).then((res) => {
        if (res.data.code === '200') {
          _g.toastMsg('success', res.data.message)
          router.push('/home/administrative/user-list')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 获取成员详情
    getAllUserDetail() {
      getMemberDetail({id: this.$route.query.id}).then((res) => {
        if (res.data.code === '200') {
          let memberInfoDetail = res.data.result
          if (memberInfoDetail.structureData == null) {
            memberInfoDetail.structureData = []
          }
          memberInfoDetail.deptId = memberInfoDetail.structureData[memberInfoDetail.structureData.length-1]
          this.form = {
            id: memberInfoDetail.id || '',
            wineOrg: memberInfoDetail.wineOrg || [],
            username: memberInfoDetail.username || '', // 账号
            password: '', // 密码
            passwordRep: '', // 确认密码
            realname: memberInfoDetail.realname || '', // 姓名
            mobile: memberInfoDetail.mobile || '', // 手机号
            structureId: memberInfoDetail.deptId || null, // 部门id
            structureData: memberInfoDetail.structureData || [], // 部门id
            remark: memberInfoDetail.remark || '', // 备注
            groupIds: memberInfoDetail.roleIds || '' // 角色
          }
          this.recordPwd = memberInfoDetail.password
          // 角色回显
          if (memberInfoDetail.roleIds === null) {
            memberInfoDetail.roleIds = ''
          }
          let roleArr = memberInfoDetail.roleIds.split(',') || []
          let arr = []
          roleArr.map(item=> {
            arr.push(JSON.parse(item))
          })
          this.group_id = arr
          // 部门回显
          let deptArr = []
          memberInfoDetail.structureData.map(item=> {
            deptArr.push(item.toString())
          })
          this.structureId = deptArr || []
          // 组织机构回显
          if (memberInfoDetail.wineOrg === null) {
            memberInfoDetail.wineOrg = [{
              id: []
            }]
          }
          this.wineOrg = memberInfoDetail.wineOrg || [{
            id: []
          }]
        }
      })
    },
    updateDepartmentOne (val) {
      this.form.structureId = val[val.length-1]
    },
    // 获取角色
    getAllGroups() {
      let params = {
        pageNum: 1,
        pageSize: 10000,
        keyword: ''
      }
      getRoleList(params).then((res) => {
        if (res.data.code === '200') {
          this.groups = res.data.result.list || []
        } else {
          this.groups = []
        }
      })
    },
    // 过滤树中的空数组
    getTreeData (data) {
      // 循环遍历json数据
      for (var i = 0; i < data.length; i++) {
        delete data[i].hasChildren
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          this.getTreeData(data[i].children)
        }
      }
      return data
    },
    // 获取部门
    getDepartmentList() {
      getDepartmentList({name: ''}).then((res) => {
        if (res.data.code === '200') {
          if (res.data.result.id == -1) {
            this.orgsOptions = this.getTreeData(res.data.result.children) || []
          } else {
            let arr = []
            arr.push(res.data.result)
            this.orgsOptions = this.getTreeData(arr)
          }
        } else {
          this.orgsOptions = []
        }
      })
    }
  },
  created() {
    // 获取角色列表
    this.getAllGroups()
    // 获取组织机构列表
    this.getListTree()
    // 获取部门列表
    this.getDepartmentList()

    this.getAllUserDetail()
  }
}
</script>
<style type="text/css" scoped>
  .el-form-item{
    margin-left: 200px;
  }
  .box-content-div{
    margin:0 auto;
  }
  .page-content {
    overflow-x: hidden;
  }
</style>
